import { HubTableContext } from "./hub-table.context";
import type { HubTableProps } from "./types-hub-table";
import { useHubTable } from "./use-hub-table";
import { HubTableView } from "./view-hub-table";

/**
 * Tabela das listagens sobre o `DataTable` do Prime: lazy, ordenação no cabeçalho, paginador do Hub, densidade e colunas
 * das configurações, os estados da lista e a calha de rolagem dentro da moldura.
 */
export function HubTableRoot<T, C extends string = string, F extends string = string>({
  children,
  ...options
}: HubTableProps<T, C, F>) {
  const viewModel = useHubTable<T, C, F>(options, children);

  return (
    <HubTableContext.Provider value={viewModel}>
      <HubTableView
        view={viewModel.view}
        className={viewModel.className}
        style={viewModel.style}
        testId={viewModel.testId}
        rest={viewModel.rest}
        classNames={viewModel.classNames}
        size={viewModel.size}
        tableId={viewModel.tableId}
        isLoading={viewModel.isLoading}
      />
    </HubTableContext.Provider>
  );
}
HubTableRoot.displayName = "HubTable.Root";
